webpackJsonp([35783957827783],{

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(46);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IndexPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = { currentTag: 'official', sortMode: 'stars' }, _this.toggleMode = function (tag) {
	      return function () {
	        return _this.setState({ currentTag: tag });
	      };
	    }, _this.toggleSort = function (mode) {
	      return function () {
	        return _this.setState({ sortMode: mode });
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  IndexPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var data = this.props.data;
	    var allMarkdownRemark = data.allMarkdownRemark;
	    var edges = allMarkdownRemark.edges;
	    var _state = this.state,
	        currentTag = _state.currentTag,
	        sortMode = _state.sortMode;
	
	    var tags = new Set();
	    edges.forEach(function (_ref) {
	      var node = _ref.node;
	      return node.frontmatter.tags && node.frontmatter.tags.forEach(function (tag) {
	        return tags.add(tag);
	      });
	    });
	    tags = Array.from(tags).sort(function (a, b) {
	      return a.localeCompare(b);
	    });
	    var tools = currentTag === 'all' ? edges : edges.filter(function (edge) {
	      return edge.node.frontmatter.tags.includes(currentTag);
	    });
	    return _react2.default.createElement(
	      'article',
	      { className: 'post post-tools', style: { padding: '0px 20px' } },
	      _react2.default.createElement(
	        'header',
	        { className: 'post-header clearfix' },
	        _react2.default.createElement(
	          'div',
	          { className: 'post-head-wrap' },
	          ' ',
	          _react2.default.createElement(
	            'div',
	            { className: 'post-head-content' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'post-title' },
	              'Gatsby Starters by Tags'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'An ever growing list of gatsby starters. (manually tagged)'
	            )
	          ),
	          ' ',
	          _react2.default.createElement('img', {
	            className: 'illustration',
	            src: 'https://d33wubrfki0l68.cloudfront.net/6a096d617ad46fcb522c647cf847af91f2982b9d/3c13a/images/illustration-tools.svg',
	            width: '94',
	            height: '86',
	            alt: 'Design System Tools'
	          })
	        ),
	        ' '
	      ),
	      'Sort  ',
	      _react2.default.createElement(
	        'ul',
	        { className: 'filter' },
	        _react2.default.createElement(
	          'li',
	          { className: 'chron' === sortMode && 'active' },
	          _react2.default.createElement(
	            'a',
	            { onClick: this.toggleSort('chron') },
	            _react2.default.createElement(
	              'span',
	              { className: 'number' },
	              'Most Recent'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'li',
	          { className: 'stars' === sortMode && 'active' },
	          _react2.default.createElement(
	            'a',
	            { onClick: this.toggleSort('stars') },
	            _react2.default.createElement(
	              'span',
	              { className: 'number' },
	              'Stars'
	            )
	          )
	        )
	      ),
	      'Tags   ',
	      _react2.default.createElement(
	        'ul',
	        { className: 'filter' },
	        _react2.default.createElement(
	          'li',
	          { className: currentTag === 'all' && 'active' },
	          _react2.default.createElement(
	            'a',
	            { onClick: this.toggleMode('all') },
	            'All ',
	            _react2.default.createElement(
	              'span',
	              { className: 'number' },
	              '(',
	              edges.length,
	              ')'
	            )
	          )
	        ),
	        ' ',
	        tags.map(function (tag) {
	          return _react2.default.createElement(
	            'li',
	            { key: tag, className: tag === currentTag && 'active' },
	            _react2.default.createElement(
	              'a',
	              { onClick: _this2.toggleMode(tag) },
	              _react2.default.createElement(
	                'span',
	                { className: 'number' },
	                capitalizeFirstLetter(tag)
	              )
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'post-content holder' },
	        tools.sort(function (a, b) {
	          var a1 = void 0,
	              b1 = void 0;
	          switch (sortMode) {
	            case 'stars':
	              a1 = a.node.fields.stars;
	              b1 = b.node.fields.stars;
	              return b1 - a1;
	            default:
	              a1 = new Date(a.node.fields.lastUpdated);
	              b1 = new Date(b.node.fields.lastUpdated);
	              // console.log({ a1, b1, comp: a1 - b1 })
	              return b1 - a1;
	          }
	        }).map(function (art) {
	          var _art$node$frontmatter = art.node.frontmatter,
	              demo = _art$node$frontmatter.demo,
	              repo = _art$node$frontmatter.repo,
	              features = _art$node$frontmatter.features,
	              tags = _art$node$frontmatter.tags,
	              title = _art$node$frontmatter.title;
	          var _art$node$fields = art.node.fields,
	              stub = _art$node$fields.stub,
	              slug = _art$node$fields.slug,
	              githubData = _art$node$fields.githubData,
	              description = _art$node$fields.description,
	              githubFullName = _art$node$fields.githubFullName,
	              lastUpdated = _art$node$fields.lastUpdated,
	              stars = _art$node$fields.stars;
	          // console.log({ allDependencies })
	          // console.log('art.node.fields', art.node.fields)
	
	          return _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              className: 'block block-tools',
	              to: stub,
	              title: art.node.frontmatter.title,
	              key: stub
	            },
	            ' ',
	            _react2.default.createElement(
	              'div',
	              { className: 'img-wrap' },
	              _react2.default.createElement('img', {
	                src: '/images/_starters/' + stub + '.png',
	                alt: repo,
	                width: '800',
	                height: '400'
	              })
	            ),
	            ' ',
	            _react2.default.createElement(
	              'div',
	              { className: 'content' },
	              ' ',
	              _react2.default.createElement(
	                'h2',
	                null,
	                githubFullName
	              ),
	              ' ',
	              _react2.default.createElement(
	                'em',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  stars,
	                  '\u2B50'
	                ),
	                '   ',
	                'Last Updated: ',
	                new Date(lastUpdated).toDateString()
	              ),
	              ' ',
	              _react2.default.createElement(
	                'p',
	                { className: 'clamp' },
	                description
	              ),
	              ' '
	            ),
	            ' '
	          );
	        })
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	function capitalizeFirstLetter(string) {
	  return string.split('-').map(function (str) {
	    return str.charAt(0).toUpperCase() + str.slice(1);
	  }).join(' ');
	}

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-9f251e6b12f8f7a2d302.js